import SectionHeading from '@/pages/home/components/SectionHeading';
import { browserSteps, onlineWatchFeatures } from '@/mocks/cinemaData';

export default function WatchGuideSection() {
  return (
    <section id="guide" className="bg-background-50 py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="观看指引"
          title="秋霞影院手机浏览器观看与手机在线看怎么做"
          desc="不想安装任何应用时，浏览器就是最直接的入口。下面先给出手机浏览器观看的四个步骤，再补充手机在线看常见的几种能力。"
        />

        <div className="mt-10 grid grid-cols-1 gap-8 lg:grid-cols-2 lg:gap-10">
          <div>
            <h3 className="flex items-center gap-2 font-heading text-lg font-semibold text-foreground-950">
              <i className="ri-smartphone-line text-primary-600" aria-hidden="true" />
              手机浏览器观看四步
            </h3>
            <ol className="mt-5 space-y-4">
              {browserSteps.map((step) => (
                <li key={step.step} className="flex gap-4 rounded-lg border border-background-200 bg-background-100 p-4">
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-primary-500 font-heading text-sm font-semibold text-background-50">
                    {step.step}
                  </span>
                  <div>
                    <h4 className="text-sm font-semibold text-foreground-900">{step.title}</h4>
                    <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{step.desc}</p>
                  </div>
                </li>
              ))}
            </ol>
          </div>

          <div>
            <h3 className="flex items-center gap-2 font-heading text-lg font-semibold text-foreground-950">
              <i className="ri-play-circle-line text-accent-600" aria-hidden="true" />
              手机在线看的几种能力
            </h3>
            <div className="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-2">
              {onlineWatchFeatures.map((feature) => (
                <article key={feature.title} className="rounded-lg border border-background-200 bg-background-100 p-4">
                  <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                    <i className={`${feature.icon} text-lg`} aria-hidden="true" />
                  </span>
                  <h4 className="mt-3 text-sm font-semibold text-foreground-900">{feature.title}</h4>
                  <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{feature.desc}</p>
                </article>
              ))}
            </div>
            <p className="mt-4 rounded-lg border border-background-200 bg-secondary-100/60 p-4 text-sm leading-relaxed text-foreground-700">
              <strong className="font-medium text-foreground-900">提示：</strong>
              具体的清晰度档位、缓存支持与播放体验会随来源与内容不同而变化，实际以你打开时的页面为准。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}